import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Card, CardContent, Grid, withStyles, Box,
  Paper, Divider, CardHeader, Button, Dialog, Slide,
  AppBar, Toolbar, IconButton, Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// eslint-disable-next-line import/no-extraneous-dependencies
import parse from 'html-react-parser';
import {
  ContentState, convertFromHTML, convertFromRaw, EditorState, convertToRaw,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import SuccessSnackbar from '../../../components/atoms/successSnackbar/SuccessSnackbar';
import BasicBreadcrumbs from '../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import MainBody from '../../../components/templates/mainBody/MainBody';
import FormTitle from '../../../components/atoms/formTitle/FormTitle';
import {
  actCallInitMailMagazineDetail,
  actCallUpdateMailMagazineDetail,
  actCallSendMailMagazine,
  actCallConfirmRequest,
} from '../../../redux/setting/mailMagazineDetail/action';
import urls from '../../../constants/urls';
import MailMagazineEntry from './entry/MailMagazineEntry';
import Loading from '../../../components/organisms/loading/Loading';
import ConfirmDialog from '../../../components/templates/confirmDialog/ConfirmDialog';

const styles = () => ({
  container: {
    maxHeight: '70vh',
  },
  card: {
    marginBottom: '30px',
  },
  cardHeader: {
    borderBottom: 'solid rgba(0, 0, 0, 0.15) 0.5px',
    height: '50px',
    overflow: 'hidden',
  },
  highlight: {
    backgroundColor: '#E8F0FE',
  },
  emptyTableCell: {
    textAlign: 'center',
  },
  title: {
    flex: '1 1 50%',
  },
  footer: {
    zIndex: '1000',
    width: '100%!important',
    position: 'fixed!important',
    bottom: '0',
    left: '0',
    background: '#fff',
    boxShadow: '0 -8px 10px -9px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.01), 0 5px 5px -3px rgba(0,0,0,.05)',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class MailMagazineDetail extends Component {
  constructor(props) {
    super(props);

    this.breadcrumbsText = [
      {
        url: urls.SETTING.MAIL_MAGAZINE,
        name: 'メールマガジン一覧',
      },
      {
        name: 'メールマガジン詳細',
      },
    ];

    const detailId = props.location.state.detailId || null;

    let isMain = false;
    if (props.common.user) {
      isMain = props.common.user.main;
    }

    this.state = {
      detailId,
      data: {
        entity: {},
        detail: {},
      },
      isMain,
      open: false,
      target: null,
      successSnackOpen: false,
      successSnackMessage: false,
      isConfirmOpen: false,
    };

    if (!props.location.state) {
      props.history.push({
        pathname: urls.SETTING.MAIL_MAGAZINE,
      });
    }
  }

  componentDidMount() {
    document.title = 'メールマガジン詳細';
    if (this.state.detailId) {
      this.props.dispatch(actCallInitMailMagazineDetail({
        id: this.state.detailId,
      }));
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mailMagazineDetail.data !== this.props.mailMagazineDetail.data) {
      if (this.props.mailMagazineDetail.data) {
        this.setData(this.props.mailMagazineDetail.data);
      }
    }
    if (prevProps.mailMagazineDetail.isUpdateSuccess
        !== this.props.mailMagazineDetail.isUpdateSuccess) {
      if (this.props.mailMagazineDetail.isUpdateSuccess) {
        this.setState({
          open: false,
          target: null,
          successSnackOpen: true,
          successSnackMessage: '保存しました',
        });
        this.props.dispatch(actCallInitMailMagazineDetail({
          id: this.state.detailId,
        }));
      }
    }
    if (prevProps.mailMagazineDetail.isSendMailSuccess
        !== this.props.mailMagazineDetail.isSendMailSuccess) {
      if (this.props.mailMagazineDetail.isSendMailSuccess) {
        this.setState({
          isSendMailOpen: false,
          successSnackOpen: true,
          successSnackMessage: '送信しました',
        });
        this.props.dispatch(actCallInitMailMagazineDetail({
          id: this.state.detailId,
        }));
      }
    }
    if (prevProps.mailMagazineDetail.isConfirmRequestSuccess
        !== this.props.mailMagazineDetail.isConfirmRequestSuccess) {
      if (this.props.mailMagazineDetail.isConfirmRequestSuccess) {
        this.setState({
          isConfirmOpen: false,
          successSnackOpen: true,
          successSnackMessage: '確認依頼をしました',
        });
        this.props.dispatch(actCallInitMailMagazineDetail({
          id: this.state.detailId,
        }));
      }
    }
  }

  setData = (data) => {
    this.setState({ data });
  }

  handleSuccessSnackbarClose = () => {
    this.setState({ successSnackOpen: false });
  }

  isJson = (str) => {
    if (typeof str !== 'string') return false;

    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  parseContent = (rawState) => {
    const blocksFromHTML = convertFromHTML(rawState);
    const contentState = this.isJson(rawState)
      ? convertFromRaw(JSON.parse(rawState))
      : ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
    const editorState = EditorState.createWithContent(contentState);
    const draftContent = convertToRaw(editorState.getCurrentContent());
    const html = draftToHtml(draftContent);
    return parse(html);
  }

  handleEditOpen = (target) => {
    this.setState({
      open: true,
      target,
    });
  }

  handleSave = (payload) => {
    this.props.dispatch(actCallUpdateMailMagazineDetail(payload));
  }

  handleSendMail = () => {
    this.setState({ isSendMailOpen: false });
    this.props.dispatch(actCallSendMailMagazine({ id: this.state.detailId }));
  }

  handleConfirmRequest = () => {
    this.props.dispatch(actCallConfirmRequest({ id: this.state.detailId }));
  }

  render() {
    const { classes } = this.props;
    const {
      data,
      successSnackOpen, successSnackMessage,
      open,
      target,
      isSendMailOpen,
      isConfirmOpen,
      isMain,
    } = this.state;

    return (
      <div>
        <BasicBreadcrumbs breadcrumbs={this.breadcrumbsText} />
        <MainBody>
          <Box pb={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <Card className={classes.card}>
                  <CardHeader
                    className={classes.cardHeader}
                    title="基本情報"
                    titleTypographyProps={{ variant: 'body1' }}
                    action={
                      <Button onClick={() => this.handleEditOpen(0)} color="primary">修正する</Button>
                    }
                  />
                  <CardContent>
                    <Box mt={1}>
                      <FormTitle title="タイトル" />
                      <Box>{data.entity.title ?? '設定なし'}</Box>
                    </Box>
                    <Box mt={2}>
                      <FormTitle title="ステータス" />
                      <Box>{data.entity.status ?? '設定なし'}</Box>
                    </Box>
                    <Box mt={2}>
                      <FormTitle title="送信日時" />
                      <Box>{data.entity.sendAt ?? '設定なし'}</Box>
                    </Box>
                  </CardContent>
                  <Divider />
                </Card>
                <Card mt={5}>
                  <CardHeader
                    className={classes.cardHeader}
                    title="送信条件"
                    titleTypographyProps={{ variant: 'body1' }}
                    action={
                      <Button onClick={() => this.handleEditOpen(1)} color="primary">修正する</Button>
                    }
                  />
                  <CardContent>
                    <Box mt={1}>
                      <FormTitle title="性別" />
                      <Box>{data.entity.gender ?? '設定なし'}</Box>
                    </Box>
                    <Box mt={2}>
                      <FormTitle title="年代" />
                      <Box>{data.entity.age ?? '設定なし'}</Box>
                    </Box>
                    <Box mt={2}>
                      <FormTitle title="契約商品種類" />
                      <Box>{data.entity.contractProductType ?? 'なし'}</Box>
                    </Box>
                    <Box mt={2}>
                      <FormTitle title="会員番号" />
                      <Box>{(!data.entity.memberNo || data.entity.memberNo === '') ? '設定なし' : data.entity.memberNo}</Box>
                    </Box>
                  </CardContent>
                  <Divider />
                </Card>
              </Grid>
              <Grid item xs={12} md={7}>
                <Paper>
                  <Card className={classes.card}>
                    <CardHeader
                      className={classes.cardHeader}
                      title="送信内容"
                      titleTypographyProps={{ variant: 'body1' }}
                      action={
                        <Button onClick={() => this.handleEditOpen(2)} color="primary">修正する</Button>
                      }
                    />
                    <CardContent>
                      <Box mt={1}>
                        <FormTitle title="件名" />
                        <Box>{data.entity.subject ?? '設定なし'}</Box>
                      </Box>
                      <Box mt={2}>
                        <FormTitle title="本文" />
                        <Box>{data.entity.body ? this.parseContent(data.entity.body) : '設定なし'}</Box>
                      </Box>
                    </CardContent>
                    <Divider />
                  </Card>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box position="fixed" pb={2} className={classes.footer}>
            {isMain ? (
              <Box align="center" textAlign="center" mt={2} display={{ xs: 'block', sm: 'flex' }} justifyContent="center">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.setState({ isSendMailOpen: true })}
                  endIcon={null}
                  size="large"
                >
                  送信
                </Button>
              </Box>
            ) : (
              <Box align="center" textAlign="center" mt={5} display={{ xs: 'block', sm: 'flex' }} justifyContent="center">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.setState({ isConfirmOpen: true })}
                  endIcon={null}
                  size="large"
                >
                  確認依頼
                </Button>
              </Box>
            )}
          </Box>
          <SuccessSnackbar
            open={successSnackOpen}
            handleClose={this.handleSuccessSnackbarClose}
            message={successSnackMessage}
          />
          <Dialog
            fullScreen
            open={open}
            onClose={() => this.setState({ open: false })}
            TransitionComponent={Transition}
          >
            <Loading />
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => this.setState({ open: false })} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  メールマガジン編集
                </Typography>
              </Toolbar>
            </AppBar>
            <MailMagazineEntry
              fromDetail
              target={target}
              data={data}
              onSaveDetail={this.handleSave}
            />
          </Dialog>
          <ConfirmDialog
            open={isSendMailOpen}
            handleClose={() => this.setState({ isSendMailOpen: false })}
            executeText="送信する"
            handleExecute={this.handleSendMail}
            title="メールマガジンの送信"
            contentText="選択したメールマガジンを送信します。この操作は元に戻すことができません。"
            buttonColor="primary"
          />
          <ConfirmDialog
            open={isConfirmOpen}
            handleClose={() => this.setState({ isConfirmOpen: false })}
            executeText="確認依頼"
            handleExecute={this.handleConfirmRequest}
            title="確認依頼の実行"
            contentText="確認依頼を行います。よろしいですか？"
            buttonColor="primary"
          />
        </MainBody>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mailMagazineDetail: state.mailMagazineDetail,
  common: state.common,
});

export default withStyles(styles)(withRouter(connect(mapStateToProps)(MailMagazineDetail)));
